module.exports = __webpack_public_path__ + "media/Video 2b.8f4c1b32.mp4";